import { ReplacementPanel, WorkspaceProvider, MenuShell } from '@desygner/ui-editor-menus';
import React from 'react';

import ReactAppBuilder from 'src/utils/react-app-builder';

const replacementPanelInstance = {};

export class ReplacementPanelView extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
  }

  static getInstance (type) {
    if (!replacementPanelInstance[type]) {
      return new ReplacementPanelView({
        appId: `react-replacement-panel-app-${type}`,
        targetNodeSelector: '.replacement-panel'
      });
    } else {
      return replacementPanelInstance[type];
    }
  }

  closeApp () {
    super.closeApp(this.App);
  }

  mountApp ({ type, workspace, replacement, onAssetClick }) {
    this.type = type;
    this.workspace = workspace;
    this.replacement = replacement;
    this.onAssetClick = onAssetClick;
    super.mountApp(this.App);
  }

  mapProps () {
    return {
      labels: {
        colorReplacementTitle: INKIVE.TranslateHelper.translate('tool.library.colors'),
        chooseColorLabel: INKIVE.TranslateHelper.translate('tool.restricted.option.color'),
        noAssetsReplacementLabel: INKIVE.TranslateHelper.translate('tool.library.assets.assets_replacement_unavailable')
      },
      type: this.type,
      workspace: this.workspace,
      credentials: {
        baseUrl: INKIVE.C.API_URL,
        userToken: CONFIG.api_key
      },
      cardButtons: [{
        title: 'Replace Image',
        name: 'replace',
        icon: 'arrows-circle'
      }],
      bucketName: 'virginia.webrand.com',
      companionUrl: INKIVE.C.uppy_companion_url,
      objectKey: 'virginia/company',
      options: {
        isQa: INKIVE.C.IS_QA || INKIVE.C.IS_DEV
      },
      onAssetClick: (asset) => this.onAssetClick(asset),
      replacement: this.replacement
    };
  }

  App = () => {
    const props = this.mapProps();

    return (
      <MenuShell visible={true}>
        <WorkspaceProvider>
          <ReplacementPanel {...props} />
        </WorkspaceProvider>
      </MenuShell>
    );
  };
}
